// Halls drawn as areas rather than stalls: the "other area" halls (banquet,
// conference and food court spaces) have no booths, so extractSvgLayoutData
// finds nothing in them and hallBoxesFor has no stalls to build a box from.
// Their outlines are read off the drawing once and kept here, in the drawing's
// own user space (viewBox 0 0 1191 842), keyed by the layout file's name.
//
// Layout2.svg ("Halls 2, 4, 6, 8", 2026-10-03): one building, the four halls
// side by side between the service-lift band (top wall y 277.7) and the
// washroom band (bottom wall y 558.3); walls at x 42.3 / 239.5 / 437 / 633 /
// 833.3. The Banquet Hall to their right is not a tracked hall.
//
// Replacing the drawing means re-measuring these, as with venueHalls.js.
export const LAYOUT_AREA_HALLS = {
  "layout2.svg": [
    { no: 8, HallName: "Hall 8", x: 42.3, y: 277.7, width: 197.2, height: 280.6 },
    { no: 6, HallName: "Hall 6", x: 239.5, y: 277.7, width: 197.5, height: 280.6 },
    { no: 4, HallName: "Hall 4", x: 437, y: 277.7, width: 196, height: 280.6 },
    { no: 2, HallName: "Hall 2", x: 633, y: 277.7, width: 200.3, height: 280.6 },
  ],
};

const fileKey = (layout) =>
  String((layout && layout.LayoutFilePath) || "").split(/[\\/]/).pop().trim().toLowerCase();

// The area halls of a layout, shaped like extractSvgLayoutData's halls (same
// "H<no>" ids) plus the outline (areaBox) and the isOtherArea flag.
export const areaHallsForLayout = (layout) =>
  (LAYOUT_AREA_HALLS[fileKey(layout)] || []).map(({ no, HallName, x, y, width, height }) => ({
    HallID: `H${no}`,
    HallName,
    BoothCount: 0,
    isOtherArea: true,
    areaBox: { x, y, width, height },
  }));
